import { Skeleton, SkeletonText } from '@/components/UI/Skeleton'

/**
 * RewardDetailContent の形状に合わせたスケルトンプレースホルダー。
 * 特典詳細ページのローディング中に表示する。
 *
 * NOTE: ヒーロー画像エリアの height={284} は RewardDetailContent の
 * `h-[284px]` に合わせている。CSS 変更時は追従すること。
 */
export const RewardDetailSkeleton = () => {
  return (
    <div className="flex flex-col">
      {/* ── ヒーロー画像エリア ── */}
      <Skeleton variant="rect" height={284} />

      {/* ── コンテンツエリア ── */}
      <div className="px-[16px] pt-[16px] pb-[32px]">
        {/* 特典名 */}
        <Skeleton variant="text" width="70%" height={24} />

        {/* バッジ行 + 獲得条件ボタン */}
        <div className="mt-[8px] flex items-center justify-between">
          <Skeleton variant="rect" width={80} height={24} />
          <Skeleton variant="rect" width={123} height={32} />
        </div>

        {/* 獲得状況テキスト */}
        <Skeleton variant="text" width="50%" height={20} className="mt-[8px]" />

        {/* 説明文（複数行） */}
        <SkeletonText lines={4} lastLineWidth="60%" className="mt-[40px]" />

        {/* アクションボタン */}
        <div className="mt-[40px] flex justify-center">
          <Skeleton variant="rect" width={240} height={48} />
        </div>
      </div>
    </div>
  )
}
